module.exports = __webpack_public_path__ + "media/dashboard/assets/images/microphone-07394cb9d0c85ef12833aeb75755d6c1.svg";